export default function publicpublicHolidayReducer(publicHoliday, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "year": {
      return {
        ...publicHoliday,
        years: publicHoliday.years.includes(action.value)
          ? publicHoliday.years.filter((_year) => _year !== action.value)
          : [...publicHoliday.years, action.value],
      };
    }
    case "country": {
      return {
        ...publicHoliday,
        country: action.value,
        state: publicHoliday.country === action.value ? publicHoliday.state : undefined,
      };
    }

    default:
      return { ...publicHoliday, [action.type]: action.value };
  }
}
